import React, { useEffect, memo, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleTheme } from '@reducers/theme';
import cn from 'classnames';
import styles from './loader.module.css';

const getTheme = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem('auth'))?.serverAppTheme;
  } catch {
    return null;
  }
};

const Loader = memo(({ noTransparent, notFixed, message }) => {
  const serverAppTheme = useSelector(state => state.theme.serverAppTheme);
  const dispatch = useDispatch();
  const themeChange = useMemo(
    () => JSON.parse(window.sessionStorage.getItem('auth')),
    []
  );

  useEffect(() => {
    const theme = getTheme();
    if (theme) {
      dispatch(toggleTheme(theme));
    }
  }, [dispatch]);

  const messageStyle = {
    color: 'rgb(0,0,0)',
  };

  const animationRotate = useMemo(() => {
    return [...Array(12)].map((_, i) => (
      <div
        key={i}
        className={styles.bar}
        style={{
          transform: `rotate(${i * 30}deg)`,
          animationDelay: `${i * 0.1}s`,
        }}
      />
    ));
  }, []);
  return (
    <div className={styles.modalOverlay}>
      <div className={cn('col-8 mx-3 p-0', styles.modalContent)}>
        <div className={styles.loaderContainer}>
          <div className={styles.loader}>{animationRotate}</div>
        </div>
        <div
          className={cn('fw-600 fs-16 mt-2 mb-3', styles.message)}
          style={messageStyle}
        >
          {message ? message : 'Loading...'}
        </div>
      </div>
    </div>
  );
});

Loader.displayName = 'Loader';

export default Loader;
